import React from "react"
import { getQueries } from "../functions"
import { useLocation, Link } from "react-router-dom"

const Paypal = (props: any) => {
    const location = useLocation()
    const { error, email, user_id } = getQueries(location.search)

    return (
        <div className="main">
            <div className="content">
                {error && (
                    <div>
                        <p>It seems there was an error while making the payment through Paypal</p>
                        <br />
                        <p className="alert">
                            <b>Error Description: </b> {decodeURI(error)}{" "}
                        </p>
                        <br />
                        <p>
                            If you think this has happened by a mistake, and you are sure that your card has been charged by SpeakGeorgian, please{" "}
                            <a href="https://speakgeorgian.com/contact" target="_blank">
                                contact us
                            </a>{" "}
                            quickly and mention in your message the error displayed above.
                        </p>
                        <p>Please give us a chance to resolve the issue before disputing it in Paypal!</p>
                    </div>
                )}
                {!error && email && user_id && (
                    <div>
                        <p>Thank you for your order. Please check your email ({email}) in few minutes for the confirmation.</p>
                        <p>The new lessons that you have purchased have been added to your account already.</p>
                        <p>
                            You can <Link to="/en/login">login now</Link> and start listening to them.
                        </p>
                    </div>
                )}
                {!error && email && !user_id && (
                    <div>
                        <p>
                            Thank you for your order. Please check your email ({email}) in few minutes for the confirmation email, with a link to
                            create a new account for yourself.
                        </p>
                        <p>After you create your member account, the new lessons will be available there.</p>
                        <p>
                            In case you didn’t receive our email within next 30 minutes, please{" "}
                            <a href="https://speakgeorgian.com/contact" target="_blank">
                                contact us.
                            </a>{" "}
                            Also do not forget to check your <em>spam/junk folder</em> as well!
                        </p>
                    </div>
                )}
            </div>
        </div>
    )
}

export default Paypal